import React from "react";

import { Mobile, NotMobile } from "../../../common/Responsive";
import { BaseHeader } from "../../../components/layout/headerComponents/baseHeader/BaseHeader";
import { HeaderLogo } from "../../../components/layout/headerComponents/headerLogo/HeaderLogo";
import {
  HeaderTitle,
  HeaderTitleCompact,
} from "../../../components/layout/headerComponents/headerTitle/HeaderTitle";
import { CommonHeaderUserMenu } from "../../../components/layout/headerComponents/headerUserMenu/CommonHeaderUserMenu";

import "./HomeHeader.scss";

export const HomeHeader = () => (
  <BaseHeader className="home-header">
    <NotMobile>
      <div className="home-header__content-left">
        <HeaderLogo />
        <HeaderTitle />
      </div>
    </NotMobile>
    <Mobile>
      <div className="home-header__content-left">
        <HeaderTitleCompact />
      </div>
    </Mobile>
    <div className="home-header__content-right">
      <CommonHeaderUserMenu />
    </div>
  </BaseHeader>
);
